import React from 'react';
import '../../../styles/Commons.css';
import {Card, Col, Row, Tag} from "antd";
import Ingredient from "../../../model/menudesign/Ingredient";
import Inscripcio from "../../../model/inscripcions/Inscripcio";
import Contacte from "../../../model/inscripcions/Contacte";

interface element {
    element: any
}

const InscripcioContacte = (ele: element) => {


    return (
        <Card bordered={true}>
            <Row gutter={16}>
                <Col className="gutter-row" span={8}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Telèfons</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.telefon}<br/>
                                {ele.element.telefon2}<br/>
                                {ele.element.telefon3}</div>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Email</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.email}</div>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Direcció</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.direccio}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <br/>
            <Row gutter={16}>
                <Col className="gutter-row" span={8}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Compte bancari</b>
                        </Col>
                        <Col className="gutter-row">
                            <Tag  color={ele.element.metalic ? "warning" : "success"}>{ele.element.metalic ? "Efectiu" : "Compte Bancari"}</Tag>
                            <div>{ele.element.IBAN} {ele.element.IBANentitat}
                                {ele.element.IBANoficina} {ele.element.IBANdc} {ele.element.IBANnum}</div>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Data modificació</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.modificacio}</div>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Parentesc</b>
                        </Col>
                        <Col className="gutter-row">
                            <div>{ele.element.parentesc}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    );
};
export default InscripcioContacte;
